import type { TrackDef } from '../core/types';
import { CITY_TRACK } from './track-city';
import { SUBURB_TRACK } from './track-suburb';
import { LAKE_TRACK } from './track-lake';
import { HUNGARORING_TRACK } from './track-hungaroring';

/** Elérhető pályák sorrendben; az első az alapértelmezett. */
export const TRACKS: TrackDef[] = [CITY_TRACK, SUBURB_TRACK, LAKE_TRACK, HUNGARORING_TRACK];

export const DEFAULT_TRACK: TrackDef = CITY_TRACK;

export const trackById = (id: string | null | undefined): TrackDef =>
  TRACKS.find((t) => t.id === id) ?? DEFAULT_TRACK;
